function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIosShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    points: "14.2,7.1 19.5,7.1 19.5,22.2  4.5,22.2 4.5,7.1 9.8,7.1  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    x1: 12,
    y1: 14.7,
    x2: 12,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    points: "9,4.1 12,1.1 15,4.1  "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShareIcon);
export default __webpack_public_path__ + "static/media/ios-share-icon.d2a625e8.svg";
export { ForwardRef as ReactComponent };